import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Home, Receipt, User, Briefcase, Wallet, CalendarCheck } from 'lucide-react';
import { useApp } from '../context/AppContext';

const customerItems = [
  { to: '/home', label: 'Home', icon: Home },
  { to: '/bookings', label: 'Bookings', icon: Receipt },
  { to: '/profile', label: 'Profile', icon: User },
];

const cleanerItems = [
  { to: '/cleaner/jobs', label: 'Jobs', icon: Briefcase },
  { to: '/cleaner/earnings', label: 'Earnings', icon: Wallet },
  { to: '/cleaner/attendance', label: 'Attendance', icon: CalendarCheck },
  { to: '/cleaner/profile', label: 'Profile', icon: User },
];

const BottomNav = () => {
  const { role } = useApp();
  const location = useLocation();
  const items = role === 'cleaner' ? cleanerItems : customerItems;
  const isCleaner = role === 'cleaner';

  return (
    <nav className={`md:hidden fixed bottom-0 left-0 right-0 ${isCleaner ? 'bg-[#DFF3E1]' : 'bg-white'} border-t border-neutral-200 z-40`}>
      <div className="grid" style={{ gridTemplateColumns: `repeat(${items.length}, 1fr)` }}>
        {items.map(({ to, label, icon: Icon }) => {
          const active = location.pathname === to || (to !== '/home' && location.pathname.startsWith(to));
          return (
            <NavLink key={to} to={to} className="flex flex-col items-center justify-center py-2.5 gap-0.5">
              <Icon className={`w-5 h-5 ${active ? 'text-[#2E7D32]' : 'text-neutral-500'}`} strokeWidth={active ? 2.5 : 2} />
              <span className={`text-[11px] font-medium ${active ? 'text-[#2E7D32]' : 'text-neutral-500'}`}>{label}</span>
            </NavLink>
          );
        })}
      </div>
      <div style={{ height: 'env(safe-area-inset-bottom)' }} />
    </nav>
  );
};

export default BottomNav;
